import {useQuery} from '@tanstack/react-query';
import {STATION_SIDEBAR_QUERY_KEY} from '@/query/channel/menu/queryKeys';
import {MenuReqest} from '@/types/channel/menu/menu.schema';
import {getStationTopFanList} from '@/api/channel/menu';
import {mapFanListSchemaToModel} from '@/types/channel/menu/menu.mapper';
import {StarballoonFanModel} from '@/types/channel/menu/menu.model';

const useStationTopFansQuery = (params: MenuReqest) => {
  return useQuery({
    queryKey: STATION_SIDEBAR_QUERY_KEY.TOP_FAN(params?.streamerId),
    queryFn: async (): Promise<StarballoonFanModel[]> => {
      const response = await getStationTopFanList(params?.streamerId);
      return response?.map(mapFanListSchemaToModel);
    },
    enabled: false,
  });
};

export default useStationTopFansQuery;
